import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { PageWrapper, Title } from '../../elements';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Form } from 'providers/Forms';

import { TextFieldWrapper, TextField, Button, ErrorText } from './elements';
import { useText } from 'common/hooks';

const deps = {
  form: state.account.newPasswordForm,
  error: state.account.newPasswordError,
  isSubmitting: state.account.isSubmittingNewPassword,
  fieldChanged: sequences`account.newPasswordFieldChanged`,
  createNewPassword: sequences`account.createNewPassword`,
};

export function PasswordForm({
  form,
  error,
  isSubmitting,
  fieldChanged,
  createNewPassword,
  get,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const newPasswordForm = new Form(form, get) as any;

  return (
    <PageWrapper>
      <Title as={'h2'}>{t('account.settings.password.reset_password')}</Title>
      <TextFieldWrapper>
        <TextField
          name={t('account.settings.password.current_password')}
          placeholder={t('account.settings.password.current_password')}
          whiteBG
          value={newPasswordForm.oldPassword.value}
          onChange={event =>
            fieldChanged({
              field: 'account.newPasswordForm.oldPassword',
              value: event.target.value,
            })
          }
          errorMessage={
            !newPasswordForm.oldPassword.isPristine &&
            newPasswordForm.oldPassword?.errorMessage?.phrase
              ? t(
                  newPasswordForm.oldPassword.errorMessage.phrase,
                  newPasswordForm.oldPassword.errorMessage.options
                )
              : ''
          }
        />
        <TextField
          name={t('account.settings.password.new_password')}
          placeholder={t('account.settings.password.new_password')}
          whiteBG
          value={newPasswordForm.newPassword.value}
          onChange={event =>
            fieldChanged({
              field: 'account.newPasswordForm.newPassword',
              value: event.target.value,
            })
          }
          errorMessage={
            !newPasswordForm.newPassword.isPristine &&
            newPasswordForm.newPassword?.errorMessage?.phrase
              ? t(
                  newPasswordForm.newPassword.errorMessage.phrase,
                  newPasswordForm.newPassword.errorMessage.options
                )
              : ''
          }
        />
        <TextField
          name={t('account.settings.password.confirm_password')}
          placeholder={t('account.settings.password.confirm_password')}
          whiteBG
          value={newPasswordForm.repeatPassword.value}
          onChange={event =>
            fieldChanged({
              field: 'account.newPasswordForm.repeatPassword',
              value: event.target.value,
            })
          }
          errorMessage={
            !newPasswordForm.repeatPassword.isPristine &&
            newPasswordForm.repeatPassword?.errorMessage?.phrase
              ? t(
                  newPasswordForm.repeatPassword.errorMessage.phrase,
                  newPasswordForm.repeatPassword.errorMessage.options
                )
              : ''
          }
        />
        {error && <ErrorText>{t(`errors.${error}`)}</ErrorText>}
      </TextFieldWrapper>
      <Button
        disabled={!newPasswordForm.isValid || isSubmitting}
        onClick={() => createNewPassword()}
      >
        {t('account.settings.password.change_password')}
      </Button>
    </PageWrapper>
  );
}

export default connect(deps, PasswordForm);
